module.exports = __webpack_public_path__ + "static/media/gambit-logo.6340b6c1.jpg";